import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "14px",
	height: "9px",
	viewBox: "0 0 14 9",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "mail",
			children: [/* @__PURE__ */ _jsx("polygon", {
				id: "Path",
				points: "13.1 0 0.9 0 7 3.9"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M7,5 C6.9,5 6.8,5 6.7,4.9 L0,0.6 L0,9 L14,9 L14,0.6 L7.3,4.9 C7.2,5 7.1,5 7,5 Z",
				id: "Path"
			})]
		})
	})
});
export default SvgIcMail;
